import { Box } from '@thebouqs/ui';
import styled from '@emotion/styled';

// This ugly hack is needed to provide gray background
// on the PDP page

const OlapicWrapper = styled(Box)`
  justify-content: center;
  width: 100%;
  margin: 0 auto;
  position: relative;
  padding: 2.5rem 0;
  box-sizing: border-box;

  &::before {
    position: absolute;
    top: 0;
    z-index: -1;
    height: 100%;
    content: '';
    background-color: #f2f4f6;
    right: 50%;
    left: 50%;
    margin-right: -50vw;
    margin-left: -50vw;
    width: 100vw;
  }
`;

export default OlapicWrapper;
